import { getApiBaseUrl, getApiClient } from "./serviceconfig";
var apiBaseUrl = getApiBaseUrl();

export async function createDirectInvoice(cookies, inputs) {
    const isJson = Boolean(inputs.save_only);
    try {
        const response = await getApiClient(cookies).post(
            `${apiBaseUrl}/direct_invoices/`,
            inputs,
            { responseType: isJson ? 'json' : 'blob' },
        );
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data;
        if (responseData instanceof Blob) {
            const text = await responseData.text();
            try {
                error.response.data = JSON.parse(text);
            } catch (parseError) {
                error.response.data = {
                    message: text || 'Save request failed.',
                    code: error?.response?.status,
                };
            }
        }
        throw error;
    }
}

export async function getDirectInvoiceDetails(cookies, invoiceId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/direct_invoices/${invoiceId}/`)
                .then(response => response.data)
    }

export function deleteDirectInvoice(cookies, invoiceId) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/direct_invoices/${invoiceId}/`)
    }

export function cancelDirectInvoice(cookies, invoiceId, payload = {}) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/direct_invoices/${invoiceId}/`, payload)
        .then(response => response.data);
}

export async function updateDirectInvoice(cookies, inputs,  invoiceId) {
    const isJson = Boolean(inputs.update_only);
    try {
        const response = await getApiClient(cookies).put(
            `${apiBaseUrl}/direct_invoices/${invoiceId}/`,
            inputs,
            { responseType: isJson ? 'json' : 'blob' },
        );
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data;
        if (responseData instanceof Blob) {
            const text = await responseData.text();
            try {
                error.response.data = JSON.parse(text);
            } catch (parseError) {
                error.response.data = {
                    message: text || 'Update request failed.',
                    code: error?.response?.status,
                };
            }
        }
        throw error;
    }
}
    

    